"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoinstUtils = exports.breakpoints = void 0;
var DEFAULT_DISTANCE_BETWEEN_BREAKPOINTS = 5;
exports.breakpoints = {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xlg: '1400px'
};
var formatBreakpointValue = function (value) {
    return Number(value.replace('px', ''));
};
exports.breakpoinstUtils = {
    down: function (key) { return "@media (max-width:".concat(formatBreakpointValue(exports.breakpoints[key]), "px)"); },
    up: function (key) {
        return "@media (min-width:".concat(formatBreakpointValue(exports.breakpoints[key]) - DEFAULT_DISTANCE_BETWEEN_BREAKPOINTS / 100, "px)");
    }
};
